import React from "react";
import {
  Label,
  Switch,
  Field,
} from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
import InfoButton from "../GenericComponent/InfoButton";
import GenerateAudio from "../GenericComponent/GenerateAudio";
import FallBackContainer from "../../Containers/GenericContainer/FallBackContainer";

export default function QueueFallback(props) {
  const { t } = useTranslation();

  const setFallBackType = (newType) => {
    props.setQueue({
      ...props.queue,
      queueOverflow: {
        ...props.queue.queueOverflow,
        type: newType,
      },
    });
  };

  const updateTargetType = (_, data) => {
    props.setQueue({
      ...props.queue,
      queueOverflow: {
        ...props.queue.queueOverflow,
        targetType: data.optionValue,
      },
    });
  };

  const updateTargetId = (_, data) => {
    props.setQueue({
      ...props.queue,
      queueOverflow: {
        ...props.queue.queueOverflow,
        targetId: data.value,
      },
    });
  };

  const handleSearchUser = (user) => {
    props.setQueue({
      ...props.queue,
      queueOverflow: {
        ...props.queue.queueOverflow,
        targetId: user.id,
        displayName: user.displayName,
      },
    });
  };

  const handleQueueSelect = (selectedQueue) => {
    if (!selectedQueue) return;
    props.setQueue({
      ...props.queue,
      queueOverflow: {
        ...props.queue.queueOverflow,
        queueId: selectedQueue.value,
        queueDisplayName: selectedQueue.queueName,
      },
    });
  };

  return (
    <div className="add-queue-root" style={{ maxWidth: "50%",marginLeft:'25%!important' }}>
      <div className="queue-form-checkbox">
        <Label weight="semibold">
          {t("FALLBACK_IF_NO_AGENT_CONNECTED")}
          <InfoButton infoKey="FALLBACK_IF_NO_AGENT_CONNECTED" category="QUEUES" />
        </Label>
        <Switch 
          checked={props.queue?.fallbackIfNoAgentConnected || false}
          disabled={props.isUpdate ? !props.permissions?.canUpdate : !props.permissions?.canCreate}
          onChange={(e, data) => {
            props.setQueue({
              ...props.queue,
              fallbackIfNoAgentConnected: data.checked,
            });
          }}
        />
      </div>
     {/* {props.queue?.fallbackIfNoAgentConnected && (*/}
      <Label  weight="semibold">
          {t("QUEUE_FALLBACK")}
        {/* <InfoButton infoKey="FALLBACK_IF_NO_AGENT_CONNECTED" category="QUEUES" />*/}
        </Label>
        <div style={{ maxWidth: "97%" , marginLeft:'5rem!important'}}>
        <FallBackContainer
          typeValue={props.queue.queueOverflow?.type}
          displayName={props.queue.queueOverflow?.displayName}
          valueName={props.queue.queueOverflow?.queueDisplayName}
          setFallBackType={setFallBackType}
          valueTargetType={props.queue.queueOverflow?.targetType}
          updateTargetType={updateTargetType}
          targetId={props.queue.queueOverflow?.targetId}
          updateTargetId={updateTargetId}
          searchUser={handleSearchUser}
          onQueueSelect={handleQueueSelect}
          permissions={props.permissions}
          isUpdate={props.isUpdate}
          disabled={props.isUpdate ? !props.permissions?.canUpdate : !props.permissions?.canCreate}
        />
        </div>
    {/*}  )}*/}
      <div className="queue-form-checkbox" >
        <Label weight="semibold">
          {t("PLAY_MESSAGE_BEFORE_QUEUE_FALLBACK")}
          <InfoButton infoKey="PLAY_MESSAGE_BEFORE_QUEUE_FALLBACK" category="QUEUES" />
        </Label>
        <Switch
          checked={props.queue.queueFallBackMessage?.enabled || false}
          disabled={props.isUpdate ? !props.permissions?.canUpdate : !props.permissions?.canCreate}
          onChange={(e, data) => {
            props.setQueue({
              ...props.queue,
              queueFallBackMessage: {
                enabled: data.checked,
                type: "Text2speech",
                language: "en-US",
                text: "",
                audioFileUrl: "",
                fileName: "",
              },
            });
          }}
        />
      </div>
      {props.queue?.queueFallBackMessage &&
        props.queue?.queueFallBackMessage?.enabled === true ? (
        <GenerateAudio
          setLangue={(newLang) => {
            props.setQueue({
              ...props.queue,
              queueFallBackMessage: {
                ...props.queue.queueFallBackMessage,
                language: newLang,
                text: props.queue.queueFallBackMessage?.text || "",
              },
            });
          }}
          setDelete={() => {
            props.setQueue((prev) => ({
              ...prev,
              queueFallBackMessage: {
                ...prev.queueFallBackMessage,
                fileName: "",
                audioFileUrl: "",
                text: "",
              },
            }));
          }}
          saveAudio={(url) => {
            if (url) {
              props.setQueue({
                ...props.queue,
                queueFallBackMessage: {
                  ...props.queue.queueFallBackMessage,
                  audioFileUrl: url,
                  fileName: "",
                  type: "Text2speech",
                },
              });
            } else {
              console.error("Generated audio URL is null or undefined");
            }
          }}
          setText={(value) => {
            props.setQueue({
              ...props.queue,
              queueFallBackMessage: {
                ...props.queue.queueFallBackMessage,
                text: value,
              },
            });
          }}
          setAudio={(selectedMedia) => {
            props.setQueue({
              ...props.queue,
              queueFallBackMessage: {
                ...props.queue.queueFallBackMessage,
                fileName: selectedMedia.header,
                audioFileUrl: selectedMedia.url,
                text: "",
                type: "Audiofile",
              },
            });
          }}
          setType={(value) => {
            props.setQueue({
              ...props.queue,
              queueFallBackMessage: {
                ...props.queue.queueFallBackMessage,
                type: value,
              },
            });
          }}
          audioFileUrl={props.queue.queueFallBackMessage?.audioFileUrl}
          fileName={props.queue.queueFallBackMessage?.fileName}
          type={props.queue.queueFallBackMessage?.type}
          text={props.queue.queueFallBackMessage?.text}
          medias={props.medias}
          path={`${props.activeTenant}${"/queues/queueFallBackMessage/" +
            props.queue.queueName.replace(/\s/g, "").toLowerCase()
            }`}
          defaultLanguage={
            props.queue.queueFallBackMessage?.language || "en-US"
          }
          permissions={props.permissions}
          isUpdate={props.isUpdate}
          disabled={props.isUpdate ? !props.permissions?.canUpdate : !props.permissions?.canCreate}
        />
      ) : null}
    </div>
  );
}
